module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-5.76387406.png";